import { CIN_BELL_ID } from "../models/organization"
import type { User } from "../models/user"

const STAFF_EMAIL_REGEX = /.+@(?:nzero|asuene)\.com$/i

export const isCinBellUser = (user: User | null | undefined): boolean => {
  const cinBellEmailRegex = /.+@cinbell.com/
  const hasCinBellEmail: boolean = cinBellEmailRegex.test(user?.email ?? "")
  const hasCinBellAccess: boolean =
    user?.organizationIds.includes(Number(CIN_BELL_ID)) ?? false

  return hasCinBellEmail && hasCinBellAccess && !user?.admin
}

export const isNzeroOrAsueneStaff = (user: User | null | undefined): boolean =>
  STAFF_EMAIL_REGEX.test(user?.email ?? "")
